import { useLocalStore } from 'mobx-react';
import React, { MouseEvent, useEffect, useState } from 'react';
import { FileProcessingModalProps, Store } from '.';

type UseViewModelReturn = {
  state: Store;
  selectedValue: string;
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedDate: string | null;
  isValidDate: (dateValue: string | null) => number;
  handleOnChangeDate: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const useViewModel = ({
  handleOnClose,
  open,
}: FileProcessingModalProps): UseViewModelReturn => {
  const state = useLocalStore<Store>(() => ({
    option: '',
    openCalendar: false,
    handleOnChangeValue(value: string) {
      this.option = value;
    },
    handleOnCancel(event: MouseEvent<HTMLOrSVGElement>) {
      event.stopPropagation();
      handleOnClose();
    },
    handleClose(event: MouseEvent<HTMLOrSVGElement>, reason: string) {
      if (reason === 'backdropClick') {
        state.handleOnCancel(event);
      }
    },
    async handleOnUpload() {
      handleOnClose();
    },
  }));
  const [selectedValue, setSelectedValue] = useState<string>('process_now');

  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSelectedValue(event.target.value);
  };

  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  const isValidDate = (dateValue: string | null): number => {
    if (dateValue === null) return 0;
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    const date = new Date(dateValue);

    if (date.toString() === 'Invalid Date') return 0;
    if (`${date.getFullYear()}`.length > 4) return 0;

    return date >= today ? 1 : -1;
  };

  const handleOnChangeDate = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const { value } = event.target;
    setSelectedDate(value);
  };

  useEffect(() => {
    setSelectedValue('process_now');
    setSelectedDate(null);
  }, [open]);

  return {
    state,
    selectedValue,
    handleRadioChange,
    selectedDate,
    isValidDate,
    handleOnChangeDate,
  };
};

export default useViewModel;
